import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

import api from "../../services/api";
import { Obrigatorio } from "../../styles/global";
import Tabela from "../../components/tabela";
import { parametrosPadrao } from "../../configs/constantes";
import debug from "../../utils/debug";
import { InputText } from "primereact/inputtext";
import { CalendarField } from "../../components/CalendarField";

const TransacaoCaixa = () => {
    const classe = 'Transações de Caixa';
    const tabela = 'transacoes_caixa';
    const endpointAPI = 'vendas/transacao-caixa';
    const aviso = useRef(null);
    const inicial = { id: 0, idloja: null, descricao: null, tipo: null, valor: null, data: null };
    const [item, setItem] = useState(inicial);

    const [tituloTela, setTituloTela] = useState('');
    const [exibeTela, setExibirTela] = useState(false);
    const [listar, setListar] = useState(false);
    const [permissoesTela, setPermissoesTela] = useState(null);
    const [parametrosTela, setParametrosTela] = useState(parametrosPadrao);
    const [lojaLista, setLojaLista] = useState([]);
    const [tipoLista, setTipoLista] = useState([]);
    const [loadingFormulario, setLoadingFormulario] = useState(true);

    useEffect((e) => {
        new api().requisitar('get', `configuracao/tela/transacoes-caixa/permissoes`).then((resposta) => {
            setPermissoesTela(resposta);
            const parametros = {
                pesquisarTabela: true,
                artigo: 'a',
                nomeClasse: classe,
                tabela: tabela,
                caminhoBreadcrumb: [{ label: 'Vendas' }, { label: 'Transações de Caixa' }],
                endpointApi: endpointAPI,
                excluirRegistro: true,
                tabelaDados: {
                    reordenar: false,
                    multiplaSelecao: true,
                    apresentarDados: resposta.listar ?? false,
                    botaoAdicionar: resposta.cadastrar ?? false,
                    botaoExcluir: resposta.excluir ?? false,
                    botaoEditarRegistro: resposta.alterar ?? false,
                    botaoExcluirRegistro: resposta.excluir ?? false,
                    botaoAuditoriaRegistro: resposta.auditoria ?? false,
                    botaoVisualizarRegistro: resposta.visualizar ?? false,
                    botaoCustomizavel: null,
                    filtroStatus: false,
                    colunas: [
                        { legenda: 'Data', campo: 'data', ordenavel: true },
                        { legenda: 'Loja', campo: 'loja_nome', ordenavel: true },
                        { legenda: 'Tipo', campo: 'tipo', ordenavel: true },
                        { legenda: 'Valor', campo: 'valor', ordenavel: true },
                    ]
                },
                abrirFormulario: aoAbrirFormulario,
                finalizarPesquisa: aoListar
            }
            setParametrosTela(parametros);
        }).catch((erro) => {
            throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
        });

        new api().requisitar('get', 'cadastro/loja/combo').then((resposta) => {
            setLojaLista(resposta);
        }).catch((erro) => {
            debug(erro);
        });

        new api().requisitar('get', 'vendas/transacao-caixa/tipos-transacao').then((resposta) => {
            setTipoLista(resposta);
        }).catch((erro) => {
            debug(erro);
        });

    }, []);

    const formatarData = (data) => {
        const [ano, mes, dia] = data.split('-');
        return new Date(ano, mes - 1, dia);
    };

    const aoListar = () => setListar(false);

    const limparTela = () => {
        setItem(inicial);
        setExibirTela(false);
        setListar(true);
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
            limparTela();
        }).catch((erro) => {
            limparTela();
            debug(erro);
            aviso.current.show({ severity: 'error', summary: 'Erro', detail: (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado', life: 3000 });
        });
    };

    const aoExcluirItem = (id) => {
        confirmDialog({
            message: `Confirmar exclusão do ${classe}?`,
            header: 'Atenção',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => {
                excluir(id);
            },
        });
    };

    const aoAbrirFormulario = async (registro) => {
        setItem(inicial);
        setExibirTela(true);
        setLoadingFormulario(true);
        if (registro.id) {
            new api().requisitar('get', `${endpointAPI}/${registro.id}`).then(async (resposta) => {
                resposta.data = formatarData(resposta.data);
                setItem(resposta);
                setLoadingFormulario(false);
            }).catch((erro) => {
                debug(erro);
            })
            setTituloTela(`Alterar ${classe}`);
            
        } else {
            await verificaUsuarioLoja();
            setTituloTela(`Cadastro de ${classe}`);
            setLoadingFormulario(false);
        }
    };

    const aoSalvar = async () => {
        console.log(item)
        try {
            if (!item.idloja) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe a loja!' };
            }
            if (!item.descricao) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe uma descrição!' };
            }
            if (!item.tipo) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o tipo da transação!' };
            }
            if (!item.valor) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o valor da transação!' };
            }
            if (!item.data) {
                throw { tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe a data da transação!' };
            }

            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), item).then((resposta) => {
                aviso.current.show({ severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000 });
                limparTela();
            }).catch((erro) => {
                limparTela();
                throw { tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado' };
            });

        } catch (erro) {
            aviso.current.show({ severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000 });
        }
    };

    const aoDigitar = (e, propriedade, elemento) => {
        if (elemento === 'item') {
            const texto = (e.target && e.target.value) || e.value || '';
            let _item = { ...item };
            _item[`${propriedade}`] = texto;
            setItem(_item);
        }
    };

    const verificaUsuarioLoja = async () => {
        try {
            const loja = await new api().requisitar('get', 'cadastro/loja/usuario-loja');
            let _item = item;
            if (loja['id'] !== false) {
                setLojaLista([loja]);
                _item.idloja = loja['id'];
                setItem(_item);
            }
        } catch (erro) {
            debug(erro);
        }
    }


    const botoesAcaoTela = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={(e) => setExibirTela(false)} />
            {item.id > 0 && item.status > 0 && permissoesTela.exluir && <Button label="Excluir" icon="pi pi-times" className="p-button-text" onClick={(e) => aoExcluirItem(item.id)} />}
            {((item.id > 0 && permissoesTela.alterar) || permissoesTela.cadastrar) && <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={aoSalvar} />}
        </React.Fragment>);
    };

    return (
        <Tabela parametros={parametrosTela} listar={listar}>
            <Toast ref={aviso}></Toast>
            <Dialog className='fluid' header={tituloTela} style={{ maxWidth: '90%', width: '800px' }} footer={botoesAcaoTela} modal={true} visible={exibeTela} onHide={(e) => setExibirTela(false)}>
                {loadingFormulario ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                    </div>
                ) : (
                    <>
                        <div className="grid formgrid">
                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col">
                                    <label htmlFor="idloja">Loja<Obrigatorio>*</Obrigatorio> </label><br />
                                    <Dropdown filter filterInputAutoFocus className="w-full" autoComplete="none" id="idloja" value={item.idloja} options={lojaLista} onChange={(e) => aoDigitar(e, 'idloja', 'item')} optionLabel="valor"
                                        optionValue="id" required />
                                </div>
                            </div>

                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col">
                                    <label htmlFor="tipo">Tipo<Obrigatorio>*</Obrigatorio> </label><br />
                                    <Dropdown filter filterInputAutoFocus className="w-full" autoComplete="none" id="tipo" value={item.tipo} options={tipoLista} onChange={(e) => aoDigitar(e, 'tipo', 'item')} optionLabel="valor"
                                        optionValue="id" required />
                                </div>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12 mt-3">
                                <label htmlFor="descricao">Descrição<Obrigatorio>*</Obrigatorio> </label><br />
                                <InputText
                                    className="w-full"
                                    autoComplete="none"
                                    id="descricao"
                                    maxLength={200}
                                    value={item.descricao}
                                    onChange={(e) => aoDigitar(e, 'descricao', 'item')}
                                    required
                                />
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="flex col-12 p-0 mt-3">
                                <div className="field col-6">
                                    <label htmlFor="idpais">Data<Obrigatorio>*</Obrigatorio> </label><br />
                                    <CalendarField
                                        value={item.data}
                                        onChange={(e) => aoDigitar(e, 'data', 'item')}
                                        className="w-full"
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"
                                    />
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="valor">Valor<Obrigatorio>*</Obrigatorio></label><br />
                                    <InputNumber
                                        className="w-full"
                                        inputId="valor"
                                        value={item.valor}
                                        onChange={(e) => aoDigitar(e, 'valor', 'item')}
                                        mode="currency"
                                        currency="BRL"
                                        locale="pt-BR"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Dialog>
        </Tabela>
    );
}

export default TransacaoCaixa;
